<template>
  <v-container v-if="cargado" >
    <v-btn color="orange" @click="volver"  left dark> Volver </v-btn>
    <v-btn
      style="margin-left:50px" color="orange" dark  absolute right @click="obtenerSucesosUsuario()">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <h4 style="padding-top: 40px; padding-bottom: 20px">
      Sucesos de {{ this.$route.params.correo }}
    </h4>
    <v-card>
          <v-card-title>
      <v-text-field
        v-model="buscar"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columnasSucesos"
      :items="arraySucesos"
      :search="buscar"
      dense
      :sort-by.sync="valorQueOrdenaLaTabla"
      :sort-desc.sync="tipoDeOrdenacion"
      class="elevation-1"
      no-data-text="No hay datos disponibles"
      :footer-props="{
        'items-per-page-text':'Filas por pagina',
        'items-per-page-options':[-1, 30, 50, 100]
      }"
    ></v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
import { DateTime } from "luxon";
export default {
  data(){
    return{
      columnasSucesos: [
        { text: "Tipo Suceso", value: "tipoSuceso", filterable: true },
        { text: "Fecha/Hora", value: "fechaHora", filterable: true },
        { text: "IP", value: "ip", filterable: false },
        { text: "Archivo", value: "archivo", filterable: true },
        { text: "Carpeta", value: "carpeta", filterable: true },
        { text: "Compartir Archivo con", value: "emailDondeSeComparte", filterable: true }
      ],
      arraySucesos:[],
      cargado: false,
      buscar: "",
      valorQueOrdenaLaTabla: "fechaHora",
      tipoDeOrdenacion: true
    }
  },
  methods:{
    volver () {
      this.$router.go(-1);
    },

    obtenerSucesosUsuario () {
      ApiZD.obtenerSucesosDeUsuario(this.$route.params.correo)
        .then((resultado) => {
          this.completarArraySucesos(resultado.data.sucesos)
        })
        .finally(() => {
          this.cargado = true;
        });
    },
    //Obtenemos la fecha en formato correcto
    obtenerLiteralFechaHora(fecha) {
      var fechaActual = DateTime.local(DateTime.local().year,DateTime.local().month,DateTime.local().day).toISO();
      let diferenciaDias =
        DateTime.fromISO(fecha).diff(DateTime.fromISO(fechaActual)).as("days")

      if (diferenciaDias > 0 & diferenciaDias < 1 || diferenciaDias == 0)
        return "Hoy, " + DateTime.fromISO(fecha).toFormat("HH:mm");
      else if (diferenciaDias < -0 && diferenciaDias > -1)
        return "Ayer, " + DateTime.fromISO(fecha).toFormat("HH:mm");
      else return DateTime.fromISO(fecha).toFormat("DD, HH:mm");
    },

    completarArraySucesos (arraySucesosUsuario) {
      arraySucesosUsuario.forEach((suceso) =>{
        suceso['fechaHora'] = this.obtenerLiteralFechaHora(suceso['fechaHora']);

        //Sacamos el archivo y la carpeta
        if(suceso['archivo']){
          let archivo = suceso['archivo'].split("\\")
          suceso['archivo'] = archivo[archivo.length-1]

          //Eliminamos el nombre de archivo y añadimos la carpeta
          archivo.pop();
          suceso['carpeta']  = archivo.join("/")
        }
      });
      this.arraySucesos = arraySucesosUsuario;
    }
  },
  created () {
    this.obtenerSucesosUsuario();
  }
}
</script>

<style>
.colorFondo{
  background-color: black;
}
</style>